export default {
    "password.error.remain.times": (val) => `Invalid password.You have ${val} chances left.`,
    "password.error.limit.login": (val) => `Please try again after ${val} min.`,
    "ekyc2.illegal.email": "Incorrect Email Address or Password",
    "ekky2.incorrect.email.password": "Incorrect Email Address or Password",
    "ekyc2.merchant.not.exist.by.email": "incorrect email address or password",
    "ekyc2.send.forget.password.verifycode": "Only one security code can be obtained in 60 seconds.",
    "ekyc2.forget.password.verifycode.fail": "Security Code Error",
    "ekyc2.user.password.update.error": "password update fail",
    "ekyc2.merchant.verifycode.timeout": "verifycode timeout",
    "ekyc2.merchant.verify.data.empty": "verify data is empty",
    "ekyc2.newpassword.unqualified": "The password should consist of 8-16 characters, including at least one number, one lowercase, one uppercase and one special symbols",
    "ekyc2.mch.info.not.exists": "Not exists",
    "ekyc2.mch.info.cannot.be.performed": "The operation cannot be performed in the current state",
    "userName.pass.fail": "Incorrect user name or password",
    "ekyc2.mch.info.export.count.limit": "No more than 5000 records can be exported at a time",
    "ekyc2.page.no.error": "Page error",
    "ekyc2.choose.process.error": "A selected process cannot be modified",
    "ekyc2.pwd.not.the.same.error": "The passwords are not the same",
    "ekyc2.invalid.token.error": "Your session has expired. Please login again.",
    "ekyc2.invalid.merchant.error": "Invalid merchant",
    "ekyc2.information.error": "There is a problem with the information.",
    "ekyc2.select.the.process.error": "Please select the process before adding data",
    "password.error.sysparameter.null": "sysParameter not exit key:LOGIN_PWD_ERROR_LIMIT",
}